<template>
  <w-app height="100%" width="100%">
    <header>
      <MainHeader />
    </header>
    <main>
      <MainPage />
    </main>
    <footer >
      <MainFooter />
    </footer>
  </w-app>
</template>

<script>
import MainHeader from '@/components/page/MainHeader'
import MainFooter from "@/components/page/MainFooter";
import MainPage from "@/components/page/MainPage";

export default {
  name: 'App',
  components: {
    MainHeader,
    MainFooter,
    MainPage,
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>

.w-app {
  background-color: #ffffff;
  font-family: Graphik-Regular, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

header {
  color: #666;
  padding: 12px;
  background-color: #ffffff;
  min-height: 60px;
}

footer {
  margin-top:auto;
  padding: 12px;
  background-color: #1a1a1a;
  color: #ffffff;
  /* max-height: 60px; */
}

aside {
  text-transform: uppercase;
  background-color: #ffffff;
  /* border-right: 1px solid rgba(0, 0, 0, 0.07); */
}

main {
  color: #666;
  background-color: #ffffff;
}

@font-face {
  font-family: "Graphik-Light";
  src: url("./assets/fonts/Graphik-Light.woff2") format("woff2");
}

@font-face {
  font-family: "Graphik-Regular";
  src: url("./assets/fonts/Graphik-Regular.woff2") format("woff2");
}

@font-face {
  font-family: "Graphik-Semibold";
  src: url("./assets/fonts/Graphik-Semibold.woff2") format("woff2");
}
</style>
